import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  ExtendedBox,
  ExtendedFlex,
  Heading,
  Body,
} from '../../../../coreui';

import FadeIn from '../../../../components/FadeIn';

const StrategySection2 = ({
  isVisible,
}) => {
  return (
    <Box width={[1, 1, 0.5, 0.5, 0.5]} height="100%">
      <ExtendedFlex flexDirection="column" height="100%">
        <ExtendedBox m={0} height={[500, 500, '50%', '50%', '50%']}>
          <ExtendedFlex
            flexDirection="column"
            justify="center"
            maxWidth={[null, null, 520, 520, 660]}
            height="100%"
            pl={['15%', '25%', 60, 100, 120]}
            pr={['15%', '25%', 10, 20, 40]}
          >
            <FadeIn>
              <Heading
                type="H3"
                textTransform="uppercase"
                m={0}
                mb="0.7em"
                opacity={isVisible ? '1' : '0'}
              >
                1031 Exchange Features
              </Heading>
              <Body type="B1" m={0} opacity={isVisible ? '1' : '0'}>
                <ul>
                  <li>100% Passive Investment Opportunities</li>
                  <li>Ability to invest funds immediately</li>
                  <li>No Agents, No Escrow, No Closing Costs</li>
                  <li>
                    Flexible Investment Amounts from $25,000 - $50,000,000
                  </li>
                  <li>
                    A Passive Income opportunity to receive monthly distributions
                  </li>
                </ul>
              </Body>
            </FadeIn>
          </ExtendedFlex>
        </ExtendedBox>
        <ExtendedBox height={[500, 500, '50%', '50%', '50%']} bg="gray.1">
          <ExtendedFlex
            flexDirection="column"
            justify="center"
            maxWidth={[null, null, 520, 520, 660]}
            height="100%"
            pl={['15%', '25%', 60, 100, 120]}
            pr={['15%', '25%', 10, 20, 40]}
          >
            <FadeIn>
              <Heading
                type="H3"
                textTransform="uppercase"
                m={0}
                mb="0.7em"
                opacity={isVisible ? '1' : '0'}
              >
                1031 Exchange Benefits
              </Heading>
              <Body type="B1" m={0} opacity={isVisible ? '1' : '0'}>
                <ul>
                  <li>
                    Defer capital gains taxes on the sale of your property, and invest in cash flowing properties
                  </li>
                  <li>Ensure certainty of closing and avoid property management headaches</li>
                  <li>
                    Diversify your portfolio with a broad range of geography and property types
                  </li>
                </ul>
              </Body>
            </FadeIn>
          </ExtendedFlex>
        </ExtendedBox>
      </ExtendedFlex>
    </Box>
  );
};

StrategySection2.propTypes = {
  isVisible: PropTypes.bool,
};

export default StrategySection2;
